// modules/toggle_module.js
export default class ToggleModule {
  constructor({
    button,
    thumb,
    toggleSelector = null,
    disableTools = [],
    ellipseData = null,
    gradingEllipseData = null,
    users,
  }) {
    this.button = button;
    this.thumb = thumb;
    this.toggleElement = toggleSelector
      ? document.querySelector(toggleSelector)
      : null;
    this.isToggled = false;
    this.disableTools = disableTools;
    this.ellipseData = ellipseData;
    this.gradingEllipseData = gradingEllipseData;
    this.users = users;
    const hasValidGradingEllipseData =
      this.gradingEllipseData &&
      Object.values(this.gradingEllipseData).some(
        (obj) => obj && typeof obj === "object" && Object.keys(obj).length > 0
      );

    if (
      (this.ellipseData ||
        (hasValidGradingEllipseData && this.users !== "adjudicator")) &&
      ((this.ellipseData && Object.keys(this.ellipseData).length > 0) ||
        hasValidGradingEllipseData)
    ) {
      this.buttonEnable(new Event("manual"));
    }
  }
  buttonEnable() {
    this.isToggled = !this.isToggled;
    this.updateUI();
  }

  updateUI() {
    if (this.isToggled) {
      // Toggle ON

      this.button.style.backgroundColor = "#77A7D7";
      this.thumb.classList.remove("left-0", "bg-white");
      this.thumb.classList.add("right-0");
      this.thumb.style.backgroundColor = "#1976D2";
      this.button.setAttribute("aria-checked", "true");
      this.toggleElement?.classList.remove("hidden");
      Array.from(this.disableTools).forEach((el) => {
        el.setAttribute("disabled", true);
        el.classList.add("opacity-50", "cursor-not-allowed");
      });
    } else {
      // Toggle OFF
      this.button.style.backgroundColor = "#838383";
      this.thumb.classList.remove("right-0");
      this.thumb.classList.add("left-0", "bg-white");
      this.thumb.style.backgroundColor = "";
      this.button.setAttribute("aria-checked", "false");
      this.toggleElement?.classList.add("hidden");
      Array.from(this.disableTools).forEach((el) => {
        el.removeAttribute("disabled");
        el.classList.remove("opacity-50", "cursor-not-allowed");
      });
    }
  }
}
